<template>
  <v-container fluid fill-height class="text-xs-center pa-0 ma-0">
    <vue-confirm-dialog></vue-confirm-dialog>
    <v-layout style="background-color: #ECECEC" class="pa-0 ma-0">
      <v-row>
        <v-flex class="lg2 md2 elevation-3" style="background-color: #95C72B">
          <v-layout class="mb-5 justify-center align-center align-self-center">
            <img src="../../public/assets/logo.png" width="80%" contain style="margin-top: 50px">
          </v-layout>
          <v-layout column>
            <v-layout class="mb-5 justify-center align-center align-self-center">
              <v-card-title style="color: white; font-weight: bold; font-size: 30px">Payment<br>Portal</v-card-title>
            </v-layout>
            <v-layout class="align-center justify-space-between column mt-5">
              <v-card-text class="pa-0 ma-0" style="font-size: 18px; color: white">Total Members</v-card-text>
              <v-card-title class="mb-0 pb-0" style="color: white; font-size: 24px">{{ this.TotalMembers }}</v-card-title>
            </v-layout>
          </v-layout>
        </v-flex>

        <v-flex class="ma-0 pa-0">
          <v-col>
            <v-layout row class="mt-5 mx-5 justify-space-between">
              <v-card-title>
                Admin Dashboard
              </v-card-title>
              <v-icon class="mx-3"
                      large
                      color="#95C72B"
                      @click="logout()"
              >
                logout
              </v-icon>
            </v-layout>

            <v-layout row class="item ml-3 mr-4" align-center>
              <v-text-field
                class="form-control"
                v-model="searchText"
                id="user_search"
                type="text"
                placeholder="Search User By Email"
                hide-details
                @keyup.enter="getUsers()"
              />
              <v-btn
                color="#8de867"
                style="border: 1px solid #8de867; color: white; font-weight: bold"
                class="button_search"
                v-on:click="getUsers()">
                SEARCH
              </v-btn>
            </v-layout>
            <v-data-table
              v-if="loadingInProgress == false"
              :headers="headers"
              :items="users"
              class="elevation-4 mt-5 mx-4"
            >
              <template column v-slot:items="user">
                <td>
                  {{user.first_name}}
                </td>

              </template>
              <template  v-slot:item.actions="{ item }">

                <v-icon
                  small
                  v-if="item['blockstatus'] == 'b'"
                  @click="blockUser(item);"
                  color="#ff0000"
                  class="mr-2">
                  block
                </v-icon>
                <v-icon
                  small
                  v-if="item['blockstatus'] != 'b'"
                  @click="blockUser(item);"
                  class="mr-2">
                  block
                </v-icon>
                <v-icon
                  small
                  @click="editUserDetails(item);"
                  v-autoscroll:arg="'tf_name'"
                  class="mr-2">
                  edit
                </v-icon>

              </template>
            </v-data-table>
            <v-layout v-if="dataLoading" class="align-center justify-center mt-5">
              <v-progress-circular
                indeterminate
                color="#95C72B"
                size="100"
              >
              </v-progress-circular>
            </v-layout>
          </v-col>
          <EditUserDetails
            ref="updateedituserdetails"
            v-if="editDetails"
            :editUserdata = "this.selecteduser"
            :editUserDetails="false"
            class="lg8"
          />
        </v-flex>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import EditUserDetails from "../components/EditUserDetails";
import {autoscroll} from "vue-autoscroll/src/vueAutoscroll";

import axios from "axios";
export default {
  name: "AdminDashboard",
  components: {EditUserDetails},
  directives: {autoscroll},
  data: () => {
    return{
      editDetails: false,
      searchText: "",
      sessionId:"",
      TotalMembers: "-",
      dataLoading: false,
      loadingInProgress: true,
      ReloadAfterStatusChange: false,
      logoutClicked: false,
      searchResults: [],
      headers: [
        { text: 'Session Id', value: '_id'},
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'actions'},
      ],
      selecteduser:{},
      users:[],
    };
  },
  mounted() {

    this.users = []
    this.getUsers();
    if(localStorage.getItem("session_id") == "" || localStorage.getItem("session_id") == null) {
      this.$router.push({name: 'AdminLogin'})
    }

  },
  created() {
    this.$socket.$subscribe('userBlockStatusUpdated', payload => {
    });
  }, methods:{
    logout(){

      this.$confirm(
        {
          message: 'Are you sure you want to logout?',
          button: {
            no: 'No',
            yes: 'Yes'
          },
          callback: confirm => {
            if (confirm) {
              this.logoutAdmin()
            }
          }
        }
      )
    },
    logoutAdmin(){
      var adminlogoutURL = this.$hostname+"/api/admin/logout"
      var adminlogoutData = new FormData();
      adminlogoutData.append("email",localStorage.getItem("email"))
      adminlogoutData.append("session",localStorage.getItem("session_id"))
      axios
        .post(adminlogoutURL, adminlogoutData)
        .then((response) => {
          if (response.data.state == "Success") {
            localStorage.setItem("email", "")
            localStorage.setItem("session_id", "")
            this.$router.push({name: "AdminLogin"})
            //console.log(response.data.message)
          }
          else if (response.data.state == "Error"){
            console.log(response.data.message)
          }
          //console.log(response)
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
        });
    },
    editUserDetails(user){
      this.selecteduser = user
      // console.log(this.selecteduser)
      // console.log("===============================")
      if(this.editDetails == true)
      {
        this.$refs.updateedituserdetails.updatecomponentvalue()
      }
      else
        this.editDetails = true;

      //const container = this.$el.querySelector("#tf_name");
      //container.scrollTop = container.scrollHeight;
      //const el = this.$refs.tf_name;
      /*const el = this.$el.querySelector("#tf_name");
      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({behavior: 'smooth'});
      }
      else{
        alert("element not found")
      }*/
    },
    blockUser(user){
      var userDetailsData = {}
      userDetailsData["user_email"] = user['email']
      userDetailsData["admin_email"] = localStorage.getItem("email")
      userDetailsData["admin_session"] = localStorage.getItem("session_id")
      if( user['blockstatus'] == 'b'){
        this.$confirm(
          {
            message: 'Are you sure you want to unblock user?',
            button: {
              no: 'No',
              yes: 'Yes'
            },
            callback: confirm => {
              if (confirm) {
                userDetailsData["block_status"] = "ub"

                this.$socket.client.emit('blockUser', userDetailsData);
                this.ReloadAfterStatusChange = true;
                this.getUsers();
              }
            }
          }
        )
      }
      else{
        this.$confirm(
          {
            message: 'Are you sure you want to block user?',
            button: {
              no: 'No',
              yes: 'Yes'
            },
            callback: confirm => {
              if (confirm) {
                userDetailsData["block_status"] = "b"
                this.$socket.client.emit('blockUser', userDetailsData);
                this.ReloadAfterStatusChange = true;
                this.getUsers();
              }
            }
          }
        )
      }
      /*this.$socket.client.emit('blockUser', userDetailsData);
      this.ReloadAfterStatusChange = true;
      this.getUsers();*/
    },

    getUsers(){
      if(this.ReloadAfterStatusChange == true)
      {
        this.dataLoading = false;
      }
      else{
        this.dataLoading = true;
      }
      var getUsersUrl = this.$hostname+"/api/admin/getusers"
      this.sessionId = localStorage.getItem("session_id");
      console.log("Session iD: " + this.sessionId)
      var loginData = new FormData();
      loginData.append("email", localStorage.getItem("email"))
      loginData.append("session",localStorage.getItem("session_id"))
      if(this.searchText != ""){
        loginData.append("searchquery", this.searchText)
      }
      else {
        loginData.append("searchquery","")
      }

      axios
        .post(getUsersUrl, loginData)
        .then((response) => {
          console.log(response)
          this.users = response.data.data
          this.TotalMembers = response.data.totalusers
          //console.log("*************")
          //console.log(this.users)
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.dataLoading = false;
          this.loadingInProgress = false;
        });
    },
  }
}
</script>

<style scoped>
.form-control {
  margin: 0px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #d4f4cd;
}
</style>



// WEBPACK FOOTER //
// src/AdminViews/AdminDashboard.vue